import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { getButtonsConfig } from "../../config/buttonsConfig";

import GenericModal from "./GenericModal";

export default function FailureModal({ additionalDetails = {} }) {
  const BUTTONS = getButtonsConfig(additionalDetails);
  return (
    <GenericModal
      iconName={SvgEnum.HisAlertCircle}
      iconColor={HNSColors.failure[500]}
      iconBgColor={HNSColors.failure[700]}
      title="Error!"
      titleColor={HNSColors.failure[500]}
      message="Something went wrong. Please check again."
      expandableError={true}
      errorDetails={additionalDetails.error || []}
      buttons={[BUTTONS.BACK]}
    />
  );
}
